<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Leisurewear Department
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Stock Orders</a>
          <ul>
            <li @click="activeMenuLink = '/leisurewear/stock-new'"><router-link to="/leisurewear/stock-new"  :class="{'is-active':activeMenuLink === '/leisurewear/stock-new'}">New Orders</router-link></li>
            <li @click="activeMenuLink = '/leisurewear/stock-inprogress'"><router-link to="/leisurewear/stock-inprogress"  :class="{'is-active':activeMenuLink === '/leisurewear/stock-inprogress'}">In Progress</router-link></li>
            
          </ul>
        </li>
        
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
export default {
  name: 'SideBarLeisurewear',
  components: {
  },
  data() {
    return { activeMenuLink: null }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  }
}

</script>



